/**
 * RegistrationStepper Component
 * 
 * Handles the step navigation and progress visualization for the multi-step
 * registration form. Provides next/previous functionality with validation.
 * 
 * @param {Object} props - Component props
 * @param {number} props.currentStep - Current step number (1-4)
 * @param {Function} props.nextStep - Function to proceed to next step
 * @param {Function} props.prevStep - Function to go back to previous step
 * @param {Function} props.handleSubmit - Function to handle form submission
 * @param {boolean} props.loading - Whether form submission is in progress
 * @returns {JSX.Element} Step navigation controls
 */

import React from 'react';

const RegistrationStepper = ({ 
  currentStep, 
  nextStep, 
  prevStep, 
  handleSubmit, 
  loading 
}) => {
  return (
    <div className="d-flex justify-content-between mt-4">
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={prevStep}
        disabled={currentStep === 1}
      >
        <i className="bi bi-arrow-left me-2"></i>
        Previous
      </button>

      {currentStep < 4 ? (
        <button
          type="button"
          className="btn btn-conference-primary"
          onClick={nextStep}
        >
          Next
          <i className="bi bi-arrow-right ms-2"></i>
        </button>
      ) : (
        <button
          type="submit"
          className="btn btn-conference-primary"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Registering...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle me-2"></i>
              Complete Registration
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default RegistrationStepper;
